import { useEffect, useState } from "react";
import {
  TableAllRes,
  TableOverallRes,
} from "../network/TableApi/tableInterfaces";
import {
  getAllAccTable,
  getOverallAccTable,
} from "../network/TableApi/tableApi";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

interface IProps {}

const OverallTable = (props: IProps) => {
  const [tableData, setTableData] = useState<Array<TableOverallRes>>();

  useEffect(() => {
    getOverallAccTable({}).then((res) => {
      setTableData(res);
    });
  }, []);
  const renderedRows = tableData?.map((row, iter) => {
    const rev = [...row.orders.overall].reverse();
    const revM = [...row.orders.month].reverse();
    const revD = [...row.orders.today].reverse();
    return (
      <TableRow
        key={row.account}
        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
      >
        <TableCell component="th" scope="row">
          <b>{row.account}</b>
        </TableCell>
        <TableCell align="right">{rev[0].factInc.toFixed(2)}%</TableCell>
        <TableCell align="right">
          {(rev[0].amountCompound * 100).toFixed(2)}%
        </TableCell>
        <TableCell align="right">{revM[0].factInc.toFixed(2)}%</TableCell>
        <TableCell align="right">{revD[0].factInc.toFixed(2)}%</TableCell>
      </TableRow>
    );
  });
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>Название счета</TableCell>
            <TableCell align="right">Фактический доход</TableCell>
            <TableCell align="right">Абсолютный доход</TableCell>
            <TableCell align="right">Фактический доход (м)</TableCell>
            <TableCell align="right">Фактический доход (д)</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{renderedRows}</TableBody>
      </Table>
    </TableContainer>
  );
};

export default OverallTable;
